import { MarketplaceItemAttributeValue, MarketplaceItemV2 } from '@fgb/core';

/**
 * The purpose of this class is to provide a common interface for all marketplace button actions.
 * This allows us to decouple the action logic from the component and make it more extensible for future actions that may require different parameters or logic.
 * Each action will implement the `invoke` method, which will be called when the button is clicked, and will receive a payload containing the necessary information to perform the action.
 */
export abstract class MarketplaceButtonAction {
  label: string;
  public abstract invoke(_: any): void;
}

export interface MarketplaceButtonActionPayload {
  item: MarketplaceItemV2;
  attribute: MarketplaceItemAttributeValue;
  quantity: number;
  customFields?: any;
}
